<template>
  <el-dialog
    title="Import Rate Card"
    visible
    top="5vh"
    width="1000px"
    :fullscreen="isFullscreen"
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <StepOne
      v-if="step === 1"
      @selected="selectedFile => file = selectedFile"
    />
    <StepTwo
      v-if="step === 2"
      ref="stepTwo"
      :file="file"
      @submit="submit"
    />
    <StepThree
      v-if="step === 3"
      ref="stepThree"
      :success-msgs="successMsgs"
      :error-msgs="errorMsgs"
    />
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>
      <el-button
        v-if="step !== 3"
        type="primary"
        :disabled="!file"
        :loading="isLoading"
        @click.native="step === 1 ? nextStep() : validate()"
      >
        {{ step === 1 ? `Next` : `Submit` }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import StepOne from '@/components/Application/Manage/RateCards/Import/StepOne'
import StepTwo from '@/components/Application/Manage/RateCards/Import/StepTwo'
import StepThree from '@/components/Application/Manage/RateCards/Import/StepThree'
import Request, { POST } from '@/plugins/sdk/Request'
export default {
  components: {
    StepOne,
    StepTwo,
    StepThree
  },
  data () {
    return {
      isLoading: false,
      isFullscreen: false,
      step: 1,
      file: null,
      successMsgs: [],
      errorMsgs: []
    }
  },
  methods: {
    nextStep () {
      this.step++
    },
    validate () {
      this.$refs.stepTwo.validate()
    },
    async submit (form, parsed, tableData) {
      this.isLoading = true
      const importData = this.$_.chunk(this.formatDataAsImportData(parsed, tableData), 200)
      try {
        form.group = new this.$sdk.ratecard_group()
        const ratecard = await this.$sdk.ratecard.create(form)
        for await (let chunk of importData) {
          const request = Object.assign(new Request(), {
            _pathname: `/ratecard/${ratecard.id}/import`,
            method: POST,
            _body: JSON.stringify(chunk)
          })
          let res = await fetch(await request.build())
          let data = await res.json()
          this.successMsgs.push(...this.$_.get(data['bulk_import_created'], 'rate_card_rates', []))
          this.errorMsgs.push(...data['bulk_import_errors'])
        }
      } catch {
        this.$message({ message: 'An error occurred while importing rate card', type: 'error' })
      } finally {
        this.isLoading = false
        this.step++
        this.$emit('imported')
      }
    },
    formatDataAsImportData (parsed, tableData) {
      const importData = []
      parsed.map(p => {
        const obj = {}
        Object.keys(p).map(key => {
          const existedTd = tableData.find(td => td.original === key)
          if (existedTd.mapping !== 'omit') {
            obj[`${existedTd.mapping}`] = p[key]
          }
        })
        importData.push(obj)
      })
      return importData
    }
  }
}
</script>

<style>

</style>
